import React from 'react';

export const CompletedIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <path
        d="M5.08882496,8.02372793 L9.75834975,2.77855672 C9.99110624,2.51254931 10.3954343,2.48559411 10.6614417,2.71835059 C10.9274491,2.95110708 10.9544043,3.3554351 10.7216478,3.62144252 L5.60164842,9.38144183 C5.35785882,9.66005851 4.92923405,9.67433016 4.6674511,9.41254722 L2.10745141,6.85254752 C1.85751589,6.60261201 1.85751589,6.19738647 2.10745141,5.94745095 C2.35738693,5.69751543 2.76261246,5.69751543 3.01254798,5.94745095 L5.08882496,8.02372793 Z"
        id="path-1"
      />
    </defs>
    <g id="Hi-fi" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Onboarding-Step-3-Copy-2" transform="translate(-423.000000, -365.000000)">
        <g id="Group-4" transform="translate(423.000000, 365.000000)">
          <circle id="Oval" fill="#FFFFFF" cx="7.5" cy="7.5" r="7.5" />
          <g id="Selector-/-Checkmark---Round-/-On">
            <path
              d="M7.67999908,0 C11.9215455,-7.79159428e-16 15.3599982,3.43845271 15.3599982,7.67999908 C15.3599982,11.9215455 11.9215455,15.3599982 7.67999908,15.3599982 C3.43845271,15.3599982 5.19439619e-16,11.9215455 0,7.67999908 C-5.19439619e-16,3.43845271 3.43845271,7.79159428e-16 7.67999908,0 Z"
              id="canvas-rectangle"
              fill="#6CDEA8"
              fillRule="nonzero"
            />
            <g id="Icons-/-1-Primary-/-Checkmark" transform="translate(1.280000, 1.920000)">
              <mask id="mask-2" fill="white">
                <path
                  d="M5.08882496,8.02372793 L9.75834975,2.77855672 C9.99110624,2.51254931 10.3954343,2.48559411 10.6614417,2.71835059 C10.9274491,2.95110708 10.9544043,3.3554351 10.7216478,3.62144252 L5.60164842,9.38144183 C5.35785882,9.66005851 4.92923405,9.67433016 4.6674511,9.41254722 L2.10745141,6.85254752 C1.85751589,6.60261201 1.85751589,6.19738647 2.10745141,5.94745095 C2.35738693,5.69751543 2.76261246,5.69751543 3.01254798,5.94745095 L5.08882496,8.02372793 Z"
                  id="path-1"
                />
              </mask>
              <path
                d="M5.08882496,8.02372793 L9.75834975,2.77855672 C9.99110624,2.51254931 10.3954343,2.48559411 10.6614417,2.71835059 C10.9274491,2.95110708 10.9544043,3.3554351 10.7216478,3.62144252 L5.60164842,9.38144183 C5.35785882,9.66005851 4.92923405,9.67433016 4.6674511,9.41254722 L2.10745141,6.85254752 C1.85751589,6.60261201 1.85751589,6.19738647 2.10745141,5.94745095 C2.35738693,5.69751543 2.76261246,5.69751543 3.01254798,5.94745095 L5.08882496,8.02372793 Z"
                id="path-1"
                fill="#FFFFFF"
                fillRule="evenodd"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const SkippedIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Hi-fi" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Onboarding-Step-3-Copy-2" transform="translate(-668.000000, -365.000000)" fillRule="nonzero">
        <g id="minus" transform="translate(668.000000, 365.000000)">
          <circle id="Oval-5" fill="#6CDEA8" cx="7.68319984" cy="7.68319984" r="7.68319984" />
          <rect id="Rectangle" fill="#FFFFFF" x="3.07327994" y="6.91487986" width="9.21983981" height="1.53663997" rx="0.768319984" />
        </g>
      </g>
    </g>
  </svg>
);

export const IosIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 305 305"
    style={{ enableBackground: 'new 0 0 305 305' }}
  >
    <g id="XMLID_228_">
      <path
        id="XMLID_229_"
        d="M40.738,112.119c-25.785,44.745-9.393,112.648,19.121,153.82C74.092,286.523,88.502,305,108.239,305
  c0.372,0,0.745-0.007,1.127-0.022c9.273-0.37,15.974-3.225,22.453-5.984c7.274-3.1,14.797-6.305,26.597-6.305
  c11.226,0,18.39,3.101,25.318,6.099c6.828,2.954,13.861,6.01,24.253,5.815c22.232-0.414,35.882-20.352,47.925-37.941
  c12.567-18.365,18.871-36.196,20.998-43.01l0.086-0.271c0.405-1.211-0.167-2.533-1.328-3.066c-0.032-0.015-0.15-0.064-0.183-0.078
  c-3.915-1.601-38.257-16.836-38.618-58.36c-0.335-33.736,25.763-51.601,30.997-54.839l0.244-0.152
  c0.567-0.365,0.962-0.944,1.096-1.606c0.134-0.661-0.006-1.349-0.386-1.905c-18.014-26.362-45.624-30.335-56.74-30.813
  c-1.613-0.161-3.278-0.242-4.95-0.242c-13.056,0-25.563,4.931-35.611,8.893c-6.936,2.735-12.927,5.097-17.059,5.097
  c-4.643,0-10.668-2.391-17.645-5.159c-9.33-3.703-19.905-7.899-31.1-7.899c-0.267,0-0.53,0.003-0.789,0.008
  C78.894,73.643,54.298,88.535,40.738,112.119z"
      />
      <path
        id="XMLID_230_"
        d="M212.101,0.002c-15.763,0.642-34.672,10.345-45.974,23.583c-9.605,11.127-18.988,29.679-16.516,48.379
  c0.155,1.17,1.107,2.073,2.284,2.164c1.064,0.083,2.15,0.125,3.232,0.126c15.413,0,32.04-8.527,43.395-22.257
  c11.951-14.498,17.994-33.104,16.166-49.77C214.544,0.921,213.395-0.049,212.101,0.002z"
      />
    </g>
  </svg>
);

export const AndroidIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 413.137 413.137"
    style={{ enableBackground: 'new 0 0 413.137 413.137' }}
  >
    <g>
      <path
        style={{ fill: '#AAC148' }}
        d="M311.358,136.395H101.779c-4.662,0-8.441,3.779-8.441,8.441v175.749
  c0,4.662,3.779,8.441,8.441,8.441h37.363v59.228c0,13.742,11.14,24.883,24.883,24.883l0,0c13.742,0,24.883-11.14,24.883-24.883
  v-59.228h34.803v59.228c0,13.742,11.14,24.883,24.883,24.883l0,0c13.742,0,24.883-11.14,24.883-24.883v-59.228h37.882
  c4.662,0,8.441-3.779,8.441-8.441V144.836C319.799,140.174,316.02,136.395,311.358,136.395z"
      />
      <path
        style={{ fill: '#AAC148' }}
        d="M57.856,136.354L57.856,136.354c-13.742,0-24.883,11.14-24.883,24.883v101.065
  c0,13.742,11.14,24.883,24.883,24.883l0,0c13.742,0,24.883-11.14,24.883-24.883V161.237
  C82.738,147.495,71.598,136.354,57.856,136.354z"
      />
      <path
        style={{ fill: '#AAC148' }}
        d="M355.281,136.354L355.281,136.354c-13.742,0-24.883,11.14-24.883,24.883v101.065
  c0,13.742,11.14,24.883,24.883,24.883l0,0c13.742,0,24.883-11.14,24.883-24.883V161.237
  C380.164,147.495,369.024,136.354,355.281,136.354z"
      />
      <path
        style={{ fill: '#AAC148' }}
        d="M103.475,124.069h205.692c5.366,0,9.368-4.943,8.266-10.195
  c-6.804-32.428-27.45-59.756-55.465-75.543l17.584-31.727c1.19-2.148,0.414-4.855-1.734-6.045
  c-2.153-1.193-4.856-0.414-6.046,1.734l-17.717,31.966c-14.511-6.734-30.683-10.495-47.734-10.495
  c-17.052,0-33.224,3.761-47.735,10.495L140.869,2.292c-1.191-2.149-3.898-2.924-6.045-1.734c-2.148,1.19-2.924,3.897-1.734,6.045
  l17.584,31.727c-28.015,15.788-48.661,43.115-55.465,75.544C94.106,119.126,98.108,124.069,103.475,124.069z M267.697,76.786
  c0,5.282-4.282,9.565-9.565,9.565c-5.282,0-9.565-4.282-9.565-9.565c0-5.282,4.282-9.565,9.565-9.565
  C263.415,67.221,267.697,71.504,267.697,76.786z M154.508,67.221c5.282,0,9.565,4.282,9.565,9.565c0,5.282-4.282,9.565-9.565,9.565
  c-5.282,0-9.565-4.282-9.565-9.565C144.943,71.504,149.225,67.221,154.508,67.221z"
      />
    </g>
  </svg>
);

export const DownloadIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.79999 10.3618L12 14.2618L16.2 10.3618" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 4.96191V13.9619" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M4.79999 15.1616V17.3616C4.79999 18.4662 5.69542 19.3616 6.79999 19.3616H17.2C18.3046 19.3616 19.2 18.4662 19.2 17.3616V15.1616"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 6.16172L7.75 12.7617L19 1.76172" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const EdgeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height={800} width={800} viewBox="1 1 300 230">
    <defs>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1 0 0 -.95 -4.61 243.92)"
        r="95.38"
        cy="68.91"
        cx="161.83"
        id="b"
      >
        <stop stopOpacity={0} offset=".72" />
        <stop stopOpacity=".53" offset=".95" />
        <stop offset={1} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(.15 -.99 -.8 -.12 172.03 -130.32)"
        r="143.24"
        cy="62.99"
        cx="-340.29"
        id="d"
      >
        <stop stopOpacity={0} offset=".76" />
        <stop stopOpacity=".5" offset=".95" />
        <stop offset={1} />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-.04 1 2.13 .08 -1184.15 -111.61)"
        r="202.43"
        cy="570.21"
        cx="113.37"
        id="e"
      >
        <stop stopColor="#35c1f1" offset={0} />
        <stop stopColor="#34c1ed" offset=".11" />
        <stop stopColor="#2fc2df" offset=".23" />
        <stop stopColor="#2bc3d2" offset=".31" />
        <stop stopColor="#36c752" offset=".67" />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(.28 .96 .78 -.23 -308.37 -153.42)"
        r="97.34"
        cy="567.97"
        cx="376.52"
        id="f"
      >
        <stop stopColor="#66eb6e" offset={0} />
        <stop stopOpacity={0} stopColor="#66eb6e" offset={1} />
      </radialGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1 0 0 -1 -4.61 261.08)"
        y2="84.03"
        x2="241.67"
        y1="84.03"
        x1="63.33"
        id="a"
      >
        <stop stopColor="#0c59a4" offset={0} />
        <stop stopColor="#114a8b" offset={1} />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1 0 0 -1 -4.61 261.08)"
        y2="40.06"
        x2="45.96"
        y1="161.39"
        x1="157.35"
        id="c"
      >
        <stop stopColor="#1b9de2" offset={0} />
        <stop stopColor="#1595df" offset=".16" />
        <stop stopColor="#0680d7" offset=".67" />
        <stop stopColor="#0078d4" offset={1} />
      </linearGradient>
    </defs>
    <path
      d="M231.07 190.54a93.73 93.73 0 01-10.54 4.71 101.87 101.87 0 01-35.9 6.46c-47.32 0-88.54-32.55-88.54-74.32a31.48 31.48 0 0116.43-27.31c-42.8 1.8-53.8 46.4-53.8 72.53 0 73.88 68.09 81.37 82.76 81.37 7.91 0 19.84-2.3 27-4.56l1.31-.44a128.34 128.34 0 0066.6-52.8 4 4 0 00-5.32-5.64z"
      fill="url(#a)"
    />
    <path
      style={{ isolation: 'isolate' }}
      d="M231.07 190.54a93.73 93.73 0 01-10.54 4.71 101.87 101.87 0 01-35.9 6.46c-47.32 0-88.54-32.55-88.54-74.32a31.48 31.48 0 0116.43-27.31c-42.8 1.8-53.8 46.4-53.8 72.53 0 73.88 68.09 81.37 82.76 81.37 7.91 0 19.84-2.3 27-4.56l1.31-.44a128.34 128.34 0 0066.6-52.8 4 4 0 00-5.32-5.64z"
      fill="url(#b)"
      opacity=".35"
    />
    <path
      d="M105.73 241.42a79.2 79.2 0 01-22.74-21.34 80.72 80.72 0 0129.53-120c3.12-1.47 8.45-4.13 15.54-4a32.35 32.35 0 0125.69 13 31.88 31.88 0 016.36 18.66c0-.21 24.46-79.6-80-79.6-43.9 0-80 41.66-80 78.21a130.15 130.15 0 0012.11 56 128 128 0 00156.38 67.11 75.55 75.55 0 01-62.78-8z"
      fill="url(#c)"
    />
    <path
      style={{ isolation: 'isolate' }}
      d="M105.73 241.42a79.2 79.2 0 01-22.74-21.34 80.72 80.72 0 0129.53-120c3.12-1.47 8.45-4.13 15.54-4a32.35 32.35 0 0125.69 13 31.88 31.88 0 016.36 18.66c0-.21 24.46-79.6-80-79.6-43.9 0-80 41.66-80 78.21a130.15 130.15 0 0012.11 56 128 128 0 00156.38 67.11 75.55 75.55 0 01-62.78-8z"
      fill="url(#d)"
      opacity=".41"
    />
    <path
      d="M152.33 148.86c-.81 1.05-3.3 2.5-3.3 5.66 0 2.61 1.7 5.12 4.72 7.23 14.38 10 41.49 8.68 41.56 8.68a59.56 59.56 0 0030.27-8.35 61.38 61.38 0 0030.43-52.88c.26-22.41-8-37.31-11.34-43.91C223.48 23.84 177.74 0 128 0A128 128 0 000 126.2c.48-36.54 36.8-66.05 80-66.05 3.5 0 23.46.34 42 10.07 16.34 8.58 24.9 18.94 30.85 29.21 6.18 10.67 7.28 24.15 7.28 29.52 0 5.37-2.74 13.33-7.8 19.91z"
      fill="url(#e)"
    />
    <path
      d="M152.33 148.86c-.81 1.05-3.3 2.5-3.3 5.66 0 2.61 1.7 5.12 4.72 7.23 14.38 10 41.49 8.68 41.56 8.68a59.56 59.56 0 0030.27-8.35 61.38 61.38 0 0030.43-52.88c.26-22.41-8-37.31-11.34-43.91C223.48 23.84 177.74 0 128 0A128 128 0 000 126.2c.48-36.54 36.8-66.05 80-66.05 3.5 0 23.46.34 42 10.07 16.34 8.58 24.9 18.94 30.85 29.21 6.18 10.67 7.28 24.15 7.28 29.52 0 5.37-2.74 13.33-7.8 19.91z"
      fill="url(#f)"
    />
  </svg>
);

export const ChromeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="1 1 176 176">
    <style
      dangerouslySetInnerHTML={{
        __html: '.B{clip-path:url(#C)}.C{fill:#3e2723}.D{fill-opacity:.15}.E{fill-opacity:.2}>',
      }}
    />
    <defs>
      <circle id="A" cx={96} cy={96} r={88} />
      <path id="B" d="M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z" />
    </defs>
    <clipPath id="C">
      <use xlinkHref="#A" />
    </clipPath>
    <g className="B" transform="translate(-7 -7)">
      <path d="M21.97 8v108h39.4L96 56h88V8z" fill="#db4437" />
      <linearGradient id="D" x1="29.34" x2="81.84" y1="75.02" y2="44.35" gradientUnits="userSpaceOnUse">
        <stop stopColor="#a52714" stopOpacity=".6" offset={0} />
        <stop stopColor="#a52714" stopOpacity={0} offset=".66" />
      </linearGradient>
      <path d="M21.97 8v108h39.4L96 56h88V8z" fill="url(#D)" />
      <path d="M62.3 115.6L22.48 47.3l-.58 1 39.54 67.8z" className="C D" />
      <use xlinkHref="#B" fill="#0f9d58" />
      <linearGradient id="E" x1="110.9" x2="52.54" y1="164.5" y2="130.3" gradientUnits="userSpaceOnUse">
        <stop stopColor="#055524" stopOpacity=".4" offset={0} />
        <stop stopColor="#055524" stopOpacity={0} offset=".33" />
      </linearGradient>
      <path d="M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z" fill="url(#E)" />
      <path d="M129.8 117.3l-.83-.48-38.4 67.15h1.15l38.1-66.64z" fill="#263238" className="D" />
      <defs>
        <path id="F" d="M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z" />
      </defs>
      <clipPath id="G">
        <use xlinkHref="#F" />
      </clipPath>
      <g clipPath="url(#G)">
        <path d="M96 56l34.65 60-38.88 68H184V56z" fill="#ffcd40" />
        <linearGradient id="H" x1="121.9" x2="136.6" y1="49.8" y2="114.1" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ea6100" stopOpacity=".3" offset={0} />
          <stop stopColor="#ea6100" stopOpacity={0} offset=".66" />
        </linearGradient>
        <path d="M96 56l34.65 60-38.88 68H184V56z" fill="url(#H)" />
      </g>
      <path d="M96 56l34.65 60-38.88 68H184V56z" fill="#ffcd40" />
      <path d="M96 56l34.65 60-38.88 68H184V56z" fill="url(#H)" />
      <defs>
        <path id="I" d="M96 56l34.65 60-38.88 68H184V56z" />
      </defs>
      <clipPath id="J">
        <use xlinkHref="#I" />
      </clipPath>
      <g clipPath="url(#J)">
        <path d="M21.97 8v108h39.4L96 56h88V8z" fill="#db4437" />
        <path d="M21.97 8v108h39.4L96 56h88V8z" fill="url(#D)" />
      </g>
    </g>
    <radialGradient id="K" cx="668.2" cy="55.95" r="84.08" gradientTransform="translate(-576)" gradientUnits="userSpaceOnUse">
      <stop stopColor="#3e2723" stopOpacity=".2" offset={0} />
      <stop stopColor="#3e2723" stopOpacity={0} offset={1} />
    </radialGradient>
    <g transform="translate(-7 -7)">
      <path d="M96 56v20.95L174.4 56z" fill="url(#K)" className="B" />
      <g className="B">
        <defs>
          <path id="L" d="M21.97 8v40.34L61.36 116 96 56h88V8z" />
        </defs>
        <clipPath id="M">
          <use xlinkHref="#L" />
        </clipPath>
        <g clipPath="url(#M)">
          <use xlinkHref="#B" fill="#0f9d58" />
          <path d="M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z" fill="url(#E)" />
        </g>
      </g>
    </g>
    <radialGradient id="N" cx="597.9" cy="48.52" r="78.04" gradientTransform="translate(-576)" gradientUnits="userSpaceOnUse">
      <stop stopColor="#3e2723" stopOpacity=".2" offset={0} />
      <stop stopColor="#3e2723" stopOpacity={0} offset={1} />
    </radialGradient>
    <path transform="translate(-7 -7)" d="M21.97 48.45l57.25 57.24L61.36 116z" fill="url(#N)" className="B" />
    <radialGradient id="O" cx="671.8" cy="96.14" r="87.87" gradientTransform="translate(-576)" gradientUnits="userSpaceOnUse">
      <stop stopColor="#263238" stopOpacity=".2" offset={0} />
      <stop stopColor="#263238" stopOpacity={0} offset={1} />
    </radialGradient>
    <g transform="translate(-7 -7)">
      <path d="M91.83 183.9l20.96-78.2 17.86 10.3z" fill="url(#O)" className="B" />
      <g className="B">
        <circle cx={96} cy={96} r={40} fill="#f1f1f1" />
        <circle cx={96} cy={96} r={32} fill="#4285f4" />
        <path d="M96 55c-22.1 0-40 17.9-40 40v1c0-22.1 17.9-40 40-40h88v-1H96z" className="C E" />
        <path
          d="M130.6 116c-6.92 11.94-19.8 20-34.6 20-14.8 0-27.7-8.06-34.6-20h-.04L8 24.48v1L61.4 117c6.92 11.94 19.8 20 34.6 20 14.8 0 27.68-8.05 34.6-20h.05v-1h-.06z"
          fill="#fff"
          fillOpacity=".1"
        />
        <path
          d="M97 56c-.17 0-.33.02-.5.03C118.36 56.3 136 74.08 136 96s-17.64 39.7-39.5 39.97c.17 0 .33.03.5.03 22.1 0 40-17.9 40-40s-17.9-40-40-40z"
          opacity=".1"
          className="C"
        />
        <path
          d="M131 117.3c3.4-5.88 5.37-12.68 5.37-19.96a39.87 39.87 0 0 0-1.87-12.09c.95 3.42 1.5 7 1.5 10.73 0 7.28-1.97 14.08-5.37 19.96l.02.04-38.88 68h1.16L131 117.3z"
          fill="#fff"
          className="E"
        />
        <path
          d="M96 9c48.43 0 87.72 39.13 88 87.5 0-.17.01-.33.01-.5 0-48.6-39.4-88-88-88S8 47.4 8 96c0 .17.01.33.01.5C8.28 48.13 47.57 9 96 9z"
          fill="#fff"
          className="E"
        />
        <path
          d="M96 183c48.43 0 87.72-39.13 88-87.5 0 .17.01.33.01.5 0 48.6-39.4 88-88 88S8 144.6 8 96c0-.17.01-.33.01-.5.27 48.37 39.56 87.5 88 87.5z"
          className="C D"
        />
      </g>
    </g>
  </svg>
);

export const WindowsIcon = () => (
  <svg width="257px" height="257px" viewBox="-0.5 0 257 257" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
    <path
      d="M0 36.357L104.62 22.11l.045 100.914-104.57.595L0 36.358zm104.57 98.293l.08 101.002L.081 221.275l-.006-87.302 104.494.677zm12.682-114.405L255.968 0v121.74l-138.716 1.1V20.246zM256 135.6l-.033 121.191-138.716-19.578-.194-101.84L256 135.6z"
      fill="#00ADEF"
    />
  </svg>
);
